module.exports = __webpack_public_path__ + "img/MarketTransactionIcon.7c2b1efa.svg";